<template>
  <div
    @click="$router.push({path: name == '+' ?  '/kids/new' : '/kids/', query:name == '+' ? {}:{ ind: index }})"
  >
    <div
      :style="`background-image: url(${getDataURI(name, 256)})`"
      :id="`${name}_${this.$props.index}`"
      :class="`head noname cs0`"
    ></div>
    <br />
    <span>{{ name == '+' ? 'Add Child' : name }}</span>
  </div>
</template>

<script>
export default {
  name: "UserHead",
  props: ["kid", 'imageOnly', 'index', 'isAddChild'],
  data() { return { image: "", name: "" } },
  mounted() {
    this.$data.name = this.$props.isAddChild == 'true' ? '+' : this.$props.kid.get('name')
  },
  methods: {
    getDataURI(name, size) {
      name = name || '';
      size = size || 60;
      var colours = [
        "#1abc9c", "#2ecc71", "#3498db", "#9b59b6", "#34495e", "#16a085", "#27ae60", "#2980b9",
        "#8e44ad", "#2c3e50",
        "#f1c40f", "#e67e22", "#e74c3c", "#fd0590", "#95a5a6", "#f39c12", "#d35400", "#c0392b",
        "#bdc3c7", "#7f8c8d"
      ]
      var nameSplit = String(name)
        .toUpperCase()
        .split(' '),
        charCodeSum = name
          .split('')
          .map((c) => {
            return c.charCodeAt(0)
          })
          .reduce((a, b) => a + b, 0)
      var initials, charIndex, colourIndex, canvas, context, dataURI;
      if (nameSplit.length == 1) {
        initials = nameSplit[0] ? nameSplit[0].charAt(0) : '?';
      } else {
        initials = nameSplit[0].charAt(0) + nameSplit[1].charAt(0);
      }
      if (window.devicePixelRatio) {
        size = (size * window.devicePixelRatio);
      }
      charIndex = (initials == '?' ? 72 : charCodeSum) - 64;
      colourIndex = charIndex % colours.length;
      canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      context = canvas.getContext("2d");
      context.fillStyle = colours[colourIndex];
      context.fillRect(0, 0, canvas.width, canvas.height);
      context.font = Math.round(canvas.width / 2) + "px Arial";
      context.textAlign = "center";
      context.fillStyle = "#FFF";
      context.fillText(initials, size / 2, size / 1.5);
      dataURI = canvas.toDataURL();
      canvas = null;
      return dataURI;
    }
  }
}
</script>